/*!
 * MONTVIELLE — site furniture (mv-site.js)
 *
 * One job: make the /cart page update in place. The page works completely without this —
 * every quantity control is a real submit button posting to /cart — so this only upgrades
 * those posts to /cart/change.js plus a Section Rendering API swap. If anything fails it
 * steps aside and lets the browser do the ordinary form post.
 */
(() => {
  'use strict';

  const page = document.querySelector('[data-mv-cartpage]');
  if (!page) return;

  const SECTION = page.dataset.mvSection;
  let busy = false;

  function swap(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-mv-cartpage]');
    if (!next) { location.reload(); return; }
    page.replaceChildren(...next.childNodes);
    document.dispatchEvent(new CustomEvent('mv:cart:changed', { detail: { source: 'cart-page' } }));
  }

  /* The submit button that was pressed carries the line key and the new quantity;
     reading it from the event is what lets one handler cover every row. */
  page.addEventListener('click', async (e) => {
    const button = e.target.closest('button[name^="updates["]');
    if (!button || busy) return;

    const name = button.getAttribute('name') || '';
    const key = name.slice(8, -1);
    const quantity = Number(button.value);
    if (!key || Number.isNaN(quantity)) return;

    e.preventDefault();
    busy = true;
    page.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: SECTION, sections_url: location.pathname })
      });
      if (!res.ok) throw new Error('change failed');
      const json = await res.json();
      if (json.sections && json.sections[SECTION]) swap(json.sections[SECTION]);
      else location.reload();
      if (window.MV && window.MV.cart && window.MV.cart.refresh) window.MV.cart.refresh().catch(() => {});
    } catch (error) {
      /* Let the page fall back to the plain form post rather than stranding the visitor. */
      const form = page.querySelector('[data-mv-cart-form]');
      if (form) {
        const relay = document.createElement('input');
        relay.type = 'hidden';
        relay.name = name;
        relay.value = String(quantity);
        form.append(relay);
        form.submit();
      }
    } finally {
      busy = false;
      page.removeAttribute('aria-busy');
    }
  });
})();
